import { FC } from 'react'

const ArrowStepIndicatorDarkDarkMobile: FC<{
  width?: string
  height?: string
}> = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_0_3)">
        <path d="M9.7619 59.5L0.238094 1V117L9.7619 59.5Z" fill="#F3F4F6" />
        <path d="M9.7619 1H0.238094L9.7619 59V1Z" fill="#F3F4F6" />
        <path d="M9.7619 117H0.238094L9.7619 59V117Z" fill="#F3F4F6" />
        <path d="M0.238094 1L9.7619 59L0.238094 117" stroke="#D1D5DB" />
      </g>
      <defs>
        <clipPath id="clip0_0_3">
          <rect width="10" height="118" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default ArrowStepIndicatorDarkDarkMobile
